// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LjAYV{position:relative;min-height:600px}@media screen and (min-width:768px){.LjAYV{width:300px}}.EhH95{width:100%;height:100%}.-D-ZX{position:absolute;top:0;left:0;display:flex;width:100%;min-height:600px;align-items:center;justify-content:space-between;border-top:1px solid #e2e2e2;border-bottom:1px solid #e2e2e2;background-color:#fff}@media screen and (min-width:768px){.-D-ZX{width:300px;border:0;border-radius:8px;box-shadow:inset 0 0 0 1px #e2e2e2}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "LjAYV",
	"articlesList": "EhH95",
	"loader": "-D-ZX"
};
module.exports = ___CSS_LOADER_EXPORT___;
